import { EmojiInputPlugin, EmojiPlugin } from '@platejs/emoji/react';

import { EmojiInputElement } from './EmojiInputElement';

/**
 * Shared emoji-autocomplete plugin bundle. This is the SINGLE sanctioned
 * integration seam: consumers (email editor here; note/conversation editors
 * in the sibling issue) spread `...EMOJI_EDITOR_PLUGINS` into their plugin
 * array. Do not hand-wire EmojiInputElement in consumers. Keep this at module
 * scope for stable plugin identity. EmojiPlugin is intentionally configured
 * without `data` (lazy-loaded in EmojiInputElement).
 */
export const EMOJI_EDITOR_PLUGINS = [
  EmojiPlugin,
  EmojiInputPlugin.withComponent(EmojiInputElement),
];
